import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <motion.header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <nav className="max-w-[1200px] mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center">
          <img
            src="https://static.wixstatic.com/media/35bb17_1270289f609d49aa946b7334865cb8f0~mv2.png/v1/fill/w_253,h_127,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/daa0609c-62be-4f5e-90dc-2240ea7c4e77.png"
            alt="KC PDR Logo"
            className="h-16 w-auto"
          />
        </div>

        {/* Navigation Links */}
        <div className="hidden md:flex items-center gap-8">
          <button
            onClick={() => scrollToSection('home')}
            className="font-montserrat font-medium text-text-dark hover:text-primary transition-colors whitespace-nowrap cursor-pointer"
          >
            Home
          </button>
          <button
            onClick={() => scrollToSection('about')}
            className="font-montserrat font-medium text-text-dark hover:text-primary transition-colors whitespace-nowrap cursor-pointer"
          >
            About
          </button>
          <button
            onClick={() => scrollToSection('projects')}
            className="font-montserrat font-medium text-text-dark hover:text-primary transition-colors whitespace-nowrap cursor-pointer"
          >
            Projects
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className="font-montserrat font-medium text-text-dark hover:text-primary transition-colors whitespace-nowrap cursor-pointer"
          >
            Contact
          </button>
        </div>

        {/* Right Side Actions */}
        <div className="flex items-center gap-4">
          <a
            href="tel:660-342-6164"
            className="hidden lg:flex items-center gap-2 font-inter text-text-dark hover:text-primary transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line text-lg"></i>
            <span className="font-medium">Call (660) 342-6164</span>
          </a>
          <button
            onClick={() => scrollToSection('contact')}
            className="bg-primary hover:bg-[#e67028] text-white font-montserrat font-semibold px-4 py-2 text-sm md:px-6 md:py-3 md:text-base rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Get Free Estimate
          </button>
        </div>
      </nav>
    </motion.header>
  );
}
